import React from 'react';
import { FormattedMessage } from 'react-intl';
import parse from 'html-react-parser';
import { IHotelDetails, IRoomsContent } from '@common-types';
import { EntireHome } from '../entire-home';
import { Properties } from '../properties';
import './style.scss';

interface IProps {
  hotel: IHotelDetails;
  rooms: IRoomsContent[];
  /**
   * The entire-home panel already leads with the bedroom and bathroom counts, and
   * states them per room, so the summary and the rules are left out here. What
   * remains is the long-form content the panel has no place for.
   */
  isQuintess?: boolean;
}

class VacationRentalInfoComponent extends React.Component<IProps> {
  render(): React.ReactNode {
    const { hotel, rooms, isQuintess } = this.props;
    const show = rooms.length === 1 && !isQuintess;
    const room = rooms[0];
    // Whole-house stays carry this in the Good to know section instead, so the tail of
    // the page is one block rather than a heading per fragment.
    const importantInformation = isQuintess ? [] : hotel.importantInformation || [];

    return (show || hotel.facilities?.length || hotel.specialInstructions?.length || importantInformation.length || hotel.other
      ?
        <>
          <div className="vacation-rental pb-0">
            <div className="rooms-search__list-text secondary-font vacation">
              <div className="rooms-search__header secondary-font" style={{ fontSize: '24px' }}><FormattedMessage id="tab.overview" /></div>
            </div>
          </div>

          {show ? <EntireHome hotel={hotel} room={room} /> : null}

          {hotel.facilities?.length
            ?
              <div className="vacation-rental">
                <h4 className="vacation-rental__title secondary-font"><FormattedMessage id="tab.vacation.facilities" /></h4>
                <p className="vacation-rental__description secondary-font">{hotel.facilities}</p>
              </div>
            : null
          }

          {hotel.specialInstructions?.length
            ?
              <div className="vacation-rental">
                <h4 className="vacation-rental__title secondary-font"><FormattedMessage id="tab.special.instructions" /></h4>
                <p className="vacation-rental__description secondary-font">{parse(hotel.specialInstructions)}</p>
              </div>
            : null
          }

          {importantInformation.length
            ?
              <div className="vacation-rental">
                <h4 className="vacation-rental__title secondary-font"><FormattedMessage id="important.information" /></h4>
                <ul className="vacation-rental__description secondary-font">{importantInformation.map((info, i) => <li key={i}>{parse(info)}</li>)}</ul>
              </div>
            : null
	      }

          {hotel.other
            ?
              <div className="vacation-rental">
                <h4 className="vacation-rental__title secondary-font"><FormattedMessage id="tab.vacation.other" /></h4>
                <p className="vacation-rental__description secondary-font">{parse(hotel.other)}</p>
              </div>
            : null
          }

          {show ? <Properties room={room} /> : null}
        </>
      : null
    );
  }
}

export const VacationRentalInfo = VacationRentalInfoComponent;